<template>
  <div>
    <section class="xlrclh">
      <img
        class="top-img"
        src="../../assets/imgs/jinjiang/9/title-bg.png"
        alt=""
      />
      <div class="technological-process">
        <div class="sxcl">
          <img
            class="top"
            src="../../assets/imgs/jinjiang/3/title-1.png"
            alt=""
          />
          <div class="content">
            人工智能、现代商贸、新兴金融、数字传媒、都市工业、都市文旅、都市医养等“1+3+3”产业领域人才。
          </div>
        </div>
        <div class="rhtj mar-t2">
          <img
            class="top"
            src="../../assets/imgs/jinjiang/7/title-2.png"
            alt=""
          />
          <div class="content">
            <div class="font" style="marginbottom: 0.1rem">
              （一）所在企业登记注册地、税收解缴关系及统计关系须均在锦江区；
            </div>
          </div>
          <div class="content">
            <div class="font">
              （二）申报人才与所在企业签订三年以上劳动合同，并承诺取得相关奖励后在企业的服务年限原则上不低于五年；
            </div>
          </div>
          <div class="content">
            <div class="font">
              （三）申报人才全职在锦江区从事相关工作两年以上，新获得国际、国内认可的具有较高含金量的荣誉奖项证书、执业等级（资格）证书。
            </div>
          </div>
        </div>
        <div class="rhtj mar-t2">
          <img
            class="top"
            src="../../assets/imgs/jinjiang/6/title-3.png"
            alt=""
          />
          <div class="content">
            <div class="font" style="marginbottom: 0.1rem">
              （一）获得Ⅰ类荣誉奖项的，给予10万元奖励；获得Ⅱ类荣誉奖项的，给予5万元奖励；获得Ⅲ类荣誉奖项的，给予2万元奖励；
            </div>
          </div>
          <div class="content">
            <div class="font">
              （二）取得国际、国内认可通用的具有较高含金量执业等级（资格）证书的，给予3万元奖励。
            </div>
          </div>
        </div>
        <div class="rhtj mar-t2">
          <img
            class="top"
            src="../../assets/imgs/jinjiang/3/title-4.png"
            alt=""
          />
          <div class="content">
            <div class="font" style="marginbottom: 0.1rem">
              （一）《锦江区人才提能争优奖励申请表》；
            </div>
          </div>
          <div class="content">
            <div class="font">
              （二）申报人才所在单位统一社会信用代码证复印件，年度纳税证明；
            </div>
          </div>
          <div class="content">
            <div class="font">
              （三）申报人才身份证（护照）复印件，社保缴纳证明、个税缴纳证明；
            </div>
          </div>
          <div class="content">
            <div class="font">
              （四）申报人才取得荣誉奖项或职业资格证书的证明材料（证书、文件等）；
            </div>
          </div>
          <div class="content">
            <div class="font">
              （五）申报人才与所在单位签订的正式劳动（聘用）合同复印件，劳动（聘用）合同签订单位须与社会保险参保单位一致；
            </div>
          </div>
          <div class="content">
            <div class="font">
              （六）申报人才从事与新取得荣誉奖项、职业资格证书相关工作两年以上的证明材料；
            </div>
          </div>
          <div class="content">
            <div class="font">（七）诚信申报承诺书。</div>
          </div>
        </div>
        <div class="sxcl">
          <img
            class="top"
            src="../../assets/imgs/jinjiang/1/title-5.png"
            alt=""
          />
          <div class="content" style="font-weight: 600">
            通过单位住所地所属街道办事处线下申请。
          </div>
        </div>
        <div class="contact">
          <img
            class="top"
            src="../../assets/imgs/jinjiang/1/title-6.png"
            alt=""
          />
          <div class="content">
            <div class="number">
              <span class="label">政策咨询电话：</span>
              <div>
                <a href="tel:028-86624369">028-86624369</a>
              </div>
            </div>
            <div class="unit">
              <span class="label">责任单位：</span>
              区委组织部（区委人才办）
            </div>
          </div>
        </div>
        <!-- <div class="codes">
          <img class="code" src="../assets/imgs/70/code.png" />
          <img class="text" src="../assets/imgs/70/text.png" />
        </div> -->
      </div>
    </section>
    <!-- <call phone="028-83221725"></call> -->
  </div>
</template>

<script>
import call from "../../components/call.vue";
export default {
  data() {
    return {};
  },

  components: {
    call,
  },

  mounted() {},

  methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";
.xlrclh {
  background-color: $base-back;

  .top-img {
    width: 100%;
    height: auto;
  }
  .technological-process {
    transform: translateY(-2.1rem);
    .rhtj {
      position: relative;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }
      .content {
        width: 6.85rem;
        background: #d4e0ff;
        margin: -0.35rem auto 0;
        padding: 0.33rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        font-size: 0.26rem;
        font-weight: 500;
        color: #4e4e4e;
        text-align: left;
        line-height: 0.44rem;
        .font {
          background-color: #fff;
          border-radius: 0.2rem;
          padding: 0.28rem 0.31rem;
        }
      }
    }

    .sxcl {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }
      .content {
        width: 6.85rem;
        background: #fff;
        margin: -0.45rem auto 0;
        padding: 0.3rem 0.54rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        padding-top: 0.28rem;
        font-size: 0.26rem;
        font-weight: 500;
        text-align: left;
        color: #4e4e4e;
        line-height: 0.44rem;
      }
    }
    .sbcl {
      position: relative;
      margin-top: 0.22rem;
      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }
      .content {
        width: 6.85rem;
        background: #e8eeff;
        margin: -0.95rem auto 0;
        padding: 0.33rem 0.24rem 0.36rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        padding-top: 0.28rem;
        font-size: 0.26rem;
        font-weight: 500;
        text-align: left;
        color: #4e4e4e;
        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.15rem 0.23rem 0.3rem;
          margin-top: 0.5rem;
          position: relative;
          .title {
            font-size: 0.3rem;
            font-weight: bold;
            color: #333333;
          }
          .item {
            margin-top: 0.3rem;
            box-sizing: border-box;
            position: relative;
            padding-left: 0.42rem;
            display: flex;
            .dot {
              width: 0.39rem;
              height: 0.39rem;
              background-color: #739bfe;
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 0.28rem;
              color: #fff;
              border-radius: 50%;
              position: absolute;
              left: -0.1rem;
              top: 0;
              z-index: 9999;
            }
          }
        }
      }
    }
    .gmlc {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }
      .content {
        width: 6.85rem;
        background: #e8eeff;
        margin: -0.55rem auto;
        padding: 0 0.33rem 0.35rem 0.36rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        .title {
          font-size: 0.36rem;
          font-weight: bold;
          color: #333333;
          text-align: left;
          line-height: 0.5rem;
        }
        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.3rem 0.23rem;
          font-size: 0.26rem;
          font-weight: 500;
          color: #4e4e4e;
          .line-item {
            font-size: 0.26rem;
            position: relative;
            z-index: 3;
            .line {
              position: absolute;
              width: 0.02rem;
              height: 100%;
              border-left: 0.02rem dashed #739bfe;
              left: 0.2rem;
              z-index: 0;
              //   background-color: #739bfe;
            }
            .line-title {
              font-size: 0.3rem;
              font-weight: bold;
              color: #3d5aa3;
            }
            .line-top {
              display: flex;
              width: 3.31rem;
              height: 0.49rem;
              background-image: url(../../assets/imgs/jinjiang/1/label.png);
              background-size: 100% 100%;
              z-index: 99;
              display: flex;
              align-items: center;
              box-sizing: border-box;
              padding-left: 0.08rem;
              .line-num {
                width: 0.39rem;
                height: 0.39rem;
                background: #fff;
                color: #3d5aa3;
                display: inline-flex;
                border-radius: 50%;
                justify-content: center;
                align-items: center;
                margin-right: 0.14rem;
                position: relative;
                z-index: 3;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 0.28rem;
                font-weight: bold;
              }
            }
            .line-content {
              //   border-left: 0.02rem dashed #739bfe;
              padding-bottom: 0.32rem;
              margin-left: 0.2rem;
              padding-left: 0.32rem;
              padding-top: 0.15rem;
              word-break: break-all;
              line-height: 0.44rem;
            }
          }
        }
      }
    }

    .codes {
      margin: 0 auto;
      margin-top: 0.25rem;
      width: 6.85rem;
      background: #fff;
      padding: 0.3rem;
      box-sizing: border-box;
      border-radius: 0.26rem;
      padding-top: 0.28rem;
      font-size: 0.26rem;
      font-weight: 500;
      color: #4e4e4e;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .code {
        width: 1.94rem;
        height: 1.94rem;
      }
      .text {
        height: 1.72rem;
      }
    }
  }
}
</style>
